module.exports = __webpack_public_path__ + "static/media/YB5M11_0.d03a510b.jpg";